import { render, staticRenderFns } from "./IndividualOrder.vue?vue&type=template&id=1ce8f71e&scoped=true&"
import script from "./IndividualOrder.vue?vue&type=script&lang=js&"
export * from "./IndividualOrder.vue?vue&type=script&lang=js&"
import style0 from "./IndividualOrder.vue?vue&type=style&index=0&id=1ce8f71e&lang=scss&scoped=true&"
import style1 from "./IndividualOrder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce8f71e",
  null
  
)

export default component.exports